import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=754b0a0e&scoped=true&"
import script from "./error-404.vue?vue&type=script&lang=js&"
export * from "./error-404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b0a0e",
  null
  
)

export default component.exports